<app-dea-widget-wrapper>
  <div class="row m-0 p-0 gap-2">
    <div class="col m-0 p-0">
      <app-dea-search-bar (text)="onText($event)"></app-dea-search-bar>
    </div>
    <div *ngIf="(sectionsState$ | async)?.ptAdminSection === true" class="col-auto m-0 p-0 d-flex gap-2">
      <button mat-stroked-button [routerLink]="'statistics'" color="primary" class="fw-bold px-3 py-1 rounded-pill">
        Statistiche
      </button>
      <button mat-flat-button color="primary" class="fw-bold px-3 py-1 rounded-pill" (click)="downloadCSV()"
        [disabled]="downloadingCsv">
        Scarica CSV
      </button>
    </div>
  </div>
  <!-- FILTERS -->
  <div class="mt-2">
    <form [formGroup]="filterForm" class="d-flex flex-row gap-4">
      <mat-radio-group formControlName="type" class="d-flex flex-row gap-2 align-items-start" color="primary">
        <mat-radio-button value="year">Anno Solare</mat-radio-button>
        <mat-radio-button value="school_year">Anno Scolastico</mat-radio-button>
        <mat-radio-button value="range">Periodo</mat-radio-button>
      </mat-radio-group>
      <div *ngIf="filterForm.get('type')?.value === 'school_year'">
        <select class="form-control dea-form-input" formControlName="school_year">
          <option *ngFor="let schoolYear of schoolYears$ | async;" [value]="schoolYear">
            {{schoolYear}}
          </option>
        </select>
      </div>
      <div *ngIf="filterForm.get('type')?.value === 'year'">
        <input type="number" formControlName="year" class="form-control dea-form-input" min="1900" max="2099"
          step="1" />
      </div>
      <div *ngIf="filterForm.get('type')?.value === 'range'" class="d-flex gap-2">
        <input type="date" formControlName="from" class="form-control dea-form-input" />
        <input type="date" formControlName="to" class="form-control dea-form-input" />
      </div>
      <select class="form-control dea-form-input" formControlName="category" style="max-width: 180px;">
        <option [value]="null">Tutte</option>
        <option *ngFor="let category of categoriesOptions$ | async;" [value]="category.value">
          {{category.label}}
        </option>
      </select>
    </form>
  </div>
  <!-- FILTERS -->
  <div class="v-spacer"></div>
  <div *ngIf="loading" class="d-flex justify-content-center align-items-center" style="height: 96px;">
    <mat-spinner strokeWidth="2" color="primary" diameter="40"></mat-spinner>
  </div>
  <div *ngIf="!loading && error" class="d-flex justify-content-center align-items-center" style="height: 96px;">
    {{error.message}}
  </div>
  <div *ngIf="!loading && !error" class="m-0 p-0">
    <div *ngFor="let purchaseTrace of purchasesTraces; let i = index;">
      <div class="border dea-radius p-3 mb-2 d-flex flex-column gap-3">
        <div class="d-flex justify-content-between align-items-center">
          <div class="fw-bold p-0" style="font-size: 1.6rem;">
            <span class="rounded me-1" [ngStyle]="{ 'background':  getColor(purchaseTrace.category ?? '') }"> </span>
            {{purchaseTrace.dea_id}}
          </div>
          <div class="hstack gap-2">
            <div class="text-capitalize">{{ purchaseTrace.createdAt | date:'d MMMM y':'':'it' }}</div>
            <div class="vr"></div>
            <button
              class="d-flex flex-column justify-content-center align-items-center dea-icon-btn btn border rounded m-0 p-0"
              (click)="editPurchaseTrace(purchaseTrace.id)" [disabled]="purchaseTrace.invoiceReceived"
              aria-label="Modifica dettagli acquisto" title="Modifica dettagli acquisto" type="button"
              [ngStyle]="{'opacity': purchaseTrace.invoiceReceived ? '0.2' : 'auto'}">
              <mat-icon class="fs-5 m-1 mt-2">edit</mat-icon>
            </button>
            <button *ngIf="(sectionsState$ | async)?.ptAdminSection === true"
              class="d-flex flex-column justify-content-center align-items-center dea-icon-btn btn border rounded m-0 p-0"
              (click)="deletePurchaseTrace(purchaseTrace.id)" [disabled]="purchaseTrace.invoiceReceived"
              [ngStyle]="{'opacity': purchaseTrace.invoiceReceived ? '0.2' : 'auto'}" type="button"
              aria-label="Elimina acquisto" title="Elimina acquisto">
              <mat-icon class="fs-5 m-1 mt-2" [ngClass]="{'text-danger': purchaseTrace.invoiceReceived === false}">
                delete
              </mat-icon>
            </button>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center gap-4">
          <div>
            {{purchaseTrace.description}}
            <span *ngIf="purchaseTrace.vendor" class="opacity-50 ms-1">[ {{purchaseTrace.vendor}} ]</span>
          </div>
          <div class="fw-semibold" style="font-size: 1.15rem;">
            {{ purchaseTrace.amount | currency:'EUR':'symbol':'1.2-2' }}
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex gap-4">
            <app-dea-user-chip [showThumbnail]="true" [showRemoveAction]="false" [user]="purchaseTrace.owner" />
            <div *ngIf="purchaseTrace.category && purchaseTrace.category.trim().length > 0"
              class="d-flex flex-column justify-content-center">
              <div class="rounded-pill px-3 py-1 m-0 border fs-065r">
                <i class="bi bi-circle-fill me-1" [ngStyle]="{ 'color':  getColor(purchaseTrace.category) }"></i>
                {{purchaseTrace.category}}
                <span
                  *ngIf="purchaseTrace.category === 'ALTRO' && purchaseTrace.custom_category !== undefined && purchaseTrace.custom_category !== ''">
                  - {{purchaseTrace.custom_category}}
                </span>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center gap-4">
            <div class="col m-0 p-0 fs-075r opacity-75">
              Allegato: <span class="fw-semibold">{{purchaseTrace.attachment ? 'Sì' : 'No'}}</span>
              <span *ngIf="purchaseTrace.attachment !== undefined" (click)="downloadAttachment(purchaseTrace)"
                class="ms-4 text-decoration-underline pointer">Scarica</span>
              <span *ngIf="purchaseTrace.attachment !== undefined && purchaseTrace.invoiceReceived === false"
                (click)="deletePurchaseTraceAttachment(purchaseTrace)" class="ms-3 text-decoration-underline pointer">
                Elimina
              </span>
            </div>
            <div class="vr"></div>
            <div class="d-flex flex-row align-items-center gap-1 me-0" style="margin-right: -10px !important;">
              <div class="flex flex-col gap-0 items-align-center justify-content-end">
                <div>Fattura ricevuta</div>
                <div *ngIf="purchaseTrace.invoiceReceived === true" class="fs-055r text-end text-capitalize">
                  {{ purchaseTrace.updatedAt | date:'d MMMM y - HH:mm':'':'it' }}
                </div>
              </div>
              <mat-checkbox class="custom-checkbox" color="primary" labelPosition="before"
                [checked]="purchaseTrace.invoiceReceived === true" [disabled]="purchaseTrace.invoiceReceived"
                (change)="onChangeInvoiceReceivedCheckbox(purchaseTrace.id)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="v-spacer"></div>
  <app-listing-pagination-bar [paginationData]="pagination" (pageEmitter)="onPage($event)"></app-listing-pagination-bar>
</app-dea-widget-wrapper>